module.exports = "pegasus_template/assets/theme6/small/5.jpg";